import { useTranslation } from "@coworker/locales";
import TitledBoxedText from "@coworker/apprestructured/src/task-management/components/TitledBoxedText/TitledBoxedText";
import { ViewerFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/ViewerFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import { getTypedValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";
import { Location } from "@coworker/apprestructured/src/task-management/types/SalesLocation";

export type LocationViewerFragmentConfigProps = {
  // Translation key for the title
  title: string;
  field: string;
};

type LocationViewerFragmentProps = {
  configProps: LocationViewerFragmentConfigProps;
  commonProps: ViewerFragmentCommonProps;
};

function LocationViewerFragment({
  configProps,
  commonProps,
}: LocationViewerFragmentProps) {
  const { field, title } = configProps;
  const { task } = commonProps;
  const location = getTypedValue<Location>(getByPath(task, field));

  const { t } = useTranslation();

  if (isLoading(location)) {
    return null;
  }

  const text = location?.slid || location?.custom || "";

  if (text.length === 0) {
    return null;
  }

  return <TitledBoxedText title={t(title)} text={text} />;
}

export default LocationViewerFragment;
